<div class="c-section-list-details">
  <ul>
    <li
      *ngIf="list.period?.description"
      class="c-section-list-details__timeperiod label {{
        timePeriodLabelClass
      }}"
    >
      {{ list.period.description }}
    </li>
    <li *ngIf="hasEditListPermission">
      <rl-list-status
        [list]="list"
        [permissions]="permissions"
      ></rl-list-status>
    </li>
    <li *ngIf="hasEditListPermission">
      <a
        class="c-section-list-details__listurl btn btn-default btn-sm"
        href="{{ listUrl }}"
        target="_blank"
        i18n="@@sectionListDetails-viewList"
      >
        View list
      </a>
    </li>
  </ul>
</div>
